
import React from 'react';
import { useSearchkit } from '@searchkit/client';
import classNames from 'classnames';
import Chip from '../../Atoms/Chip';

import './style.scss';

const makeSafeForCSS = (value) => {
  return encodeURIComponent(value)
    .replace(/\.|%[0-9a-z]{2}/gi, '');
};

export const ChipFacet = ({ facet }) => {
  const api = useSearchkit();

  return facet.entries.length > 0 && (
    <div className="Facet ChipFacet" key={facet.identifier}>
      <span>{facet.label}</span>
      <div className="ChipFacet__items">
        {facet.entries.map((entry) => {
          const isSelected = api.isFilterSelected({
            identifier: facet.identifier,
            value: entry.label,
          });
          const classes = classNames(
            'Button--Chip',
            'Chip',
            makeSafeForCSS(`Button--${entry.label}`),
            {
              'Button--selected': isSelected,
            },
          );

          return (
            <Chip
              id={entry.label}
              key={entry.label}
              text={entry.label}
              className={classes}
              checked={isSelected}
              onChange={() => {
                api.toggleFilter({ identifier: facet.identifier, value: entry.label });
                api.search();
              }} />
          );
        })}
      </div>
    </div>
  );
};

ChipFacet.DISPLAY = 'ChipFacet';
